import { DetailPageAccessMode } from '@app/detailPageLayout.models';
import { LabelWithMessage } from '@common/LabelWithMessage';
import { SignatureCard } from '@common/SignatureCard';
import { FormFieldMethods, FormTextarea } from '@gcl/react-core';
import { EPermitToLoadRemoveDetailPermitType, ECreateT4FormKeys } from './permitToLoadRemoveDetailPage.constants';
import { IProjectLoadingRemovalCert, IProjectLoadingRemovalCertS } from './permitToLoadRemoveDetailPage.models';

interface IPermitToLoadRemovalDetailPermitIceProps {
  type: EPermitToLoadRemoveDetailPermitType;
  loadingRemovalCertDetail?: IProjectLoadingRemovalCert | IProjectLoadingRemovalCertS;
  formFieldMethods: FormFieldMethods;
  mode: DetailPageAccessMode;
  isEnableIceComment: boolean;
}

export const PermitToLoadRemovalDetailPermitIce = ({
  type,
  loadingRemovalCertDetail,
  formFieldMethods,
  mode,
  isEnableIceComment,
}: IPermitToLoadRemovalDetailPermitIceProps) => {
  const title = type === EPermitToLoadRemoveDetailPermitType.load ? 'ICE Permit to Load' : 'ICE Permit to Remove';
  const content =
    type === EPermitToLoadRemoveDetailPermitType.load
      ? 'I certify that the temporary works have been checked by me and have been constructed in accordance with the above Reference Documents and the approved modifications documented in the T3 Design Changes. The temporary works conform to the requirements of the design and the documents noted above.'
      : 'I certify that any structure supported by the Temporary Works described above has become self supporting and that the Temporary Works may be dismantled or removed.';
  const remarkFormKey =
    type === EPermitToLoadRemoveDetailPermitType.load
      ? ECreateT4FormKeys.PERMIT_TO_LOAD_REMARK_ICE
      : ECreateT4FormKeys.PERMIT_TO_REMOVE_REMARK_ICE;

  return (
    <>
      <div className="gcl-mt-sm gcl-fw-700">{title}</div>
      <SignatureCard
        className="gcl-my-md"
        title="Certified by ICE"
        signUser={loadingRemovalCertDetail?.iceProjectUserProfile?.userProfile?.displayName}
        signDate={loadingRemovalCertDetail?.iceDateTime}
        signProfile={loadingRemovalCertDetail?.iceProjectUserProfile?.userProfile?.signatureUserProfile}
        onRenderContent={(signatureComponent) => {
          return (
            <div className="gcl-gems-permit-to-load-remove-permit-card-content">
              <div className="gcl-mb-md">{content}</div>

              {signatureComponent}

              <div>
                <LabelWithMessage labelFor={remarkFormKey} text="Remark" />
                <FormTextarea
                  formFieldMethods={formFieldMethods}
                  id={remarkFormKey}
                  value={formFieldMethods.getValues(remarkFormKey)}
                  disabled={!isEnableIceComment}
                />
              </div>
            </div>
          );
        }}
      />
    </>
  );
};
